
class RecentlyViewedProducts {
    constructor() {
        this.STORAGE_KEY = 'recently_viewed_products';
        this.MAX_PRODUCTS = 10;
        this.init();
    }

    init() {
        
        if (window.location.pathname.includes('/products/')) {
            this.trackCurrentProduct();
        }
    }

    async trackCurrentProduct() {
        try {
            
            const productHandle = window.location.pathname.split('/products/')[1].split('?')[0];
            
            if (!productHandle) return;

            
            const response = await fetch(`/products/${productHandle}.js`);
            const product = await response.json();

            if (product && product.id) {
                this.addToRecentlyViewed(product);
            }
        } catch (error) {
            console.error('Error', error);
        }
    }

    addToRecentlyViewed(product) {
        let recentProducts = this.getRecentlyViewed();
        
        
        recentProducts = recentProducts.filter(item => item.id !== product.id);
        
        
        const productData = {
            id: product.id,
            handle: product.handle,
            title: product.title,
            price: product.price,
            compare_at_price: product.compare_at_price,
            available: product.available,
            featured_image: product.featured_image,
            vendor: product.vendor,
            type: product.type,
            url: product.url,
            timestamp: Date.now()
        };

        recentProducts.unshift(productData);
        
       
        if (recentProducts.length > this.MAX_PRODUCTS) {
            recentProducts = recentProducts.slice(0, this.MAX_PRODUCTS);
        }

        
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(recentProducts));
        
        
        const event = new CustomEvent('recentlyViewedUpdated', {
            detail: { products: recentProducts }
        });
        document.dispatchEvent(event);
    }

    getRecentlyViewed() {
        try {
            const stored = localStorage.getItem(this.STORAGE_KEY);
            return stored ? JSON.parse(stored) : [];
        } catch (error) {
            console.error('Error', error);
            return [];
        }
    }

    clearRecentlyViewed() {
        localStorage.removeItem(this.STORAGE_KEY);
        const event = new CustomEvent('recentlyViewedUpdated', {
            detail: { products: [] }
        });
        document.dispatchEvent(event);
    }

    removeProduct(productId) {
        let recentProducts = this.getRecentlyViewed();
        recentProducts = recentProducts.filter(item => item.id !== productId);
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(recentProducts));
        
        const event = new CustomEvent('recentlyViewedUpdated', {
            detail: { products: recentProducts }
        });
        document.dispatchEvent(event);
    }

    
    async renderRecentlyViewed(containerId, limit = 6) {
        const container = document.getElementById(containerId);
        if (!container) return;

        const recentProducts = this.getRecentlyViewed();
        
        if (recentProducts.length === 0) {
            container.innerHTML = '<p class="text-center">No recently viewed products.</p>';
            return;
        }

        const productsToShow = recentProducts.slice(0, 3);
        let html = '';

        for (const product of productsToShow) {
            try {
                
                const productHTML = await this.getProductHTML(product.handle);
                html += `<div class="product-item">${productHTML}</div>`;
            } catch (error) {
                console.error('Error', error);
            }
        }

        container.innerHTML = html;
    }

    
    async getProductHTML(handle) {
        try {
            const response = await fetch(`/products/${handle}?view=grid`);
            const text = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            const productCard = doc.querySelector('.product-card, .grid-product, .product-item');
            
            if (productCard) {
                return productCard.outerHTML;
            }
            
            
            const productResponse = await fetch(`/products/${handle}.js`);
            const product = await productResponse.json();
            
            return this.generateBasicProductHTML(product);
        } catch (error) {
            console.error('Error', error);
            return '';
        }
    }

    
    generateBasicProductHTML(product) {
        const imageUrl = product.featured_image || '/assets/no-image.png';
        const price = window.Shopify ? Shopify.formatMoney(product.price) : `$${(product.price / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
        
        return `
            <div class="product-item__overlay">
                <a href="${product.url}" class="grid-link">
                    <span class="grid-link__image">
                        <img src="${imageUrl}" alt="${product.title}" loading="lazy" />
                    </span>
                    <span class="grid-link__meta">
                        <span class="grid-link__title">${product.title}</span>
                        <span class="grid-link__price">${price}</span>
                    </span>
                </a>
            </div>
        `;
    }
}


document.addEventListener('DOMContentLoaded', () => {
    window.recentlyViewedProducts = new RecentlyViewedProducts();
    window.recentlyViewedProducts.init(); 
});


window.RecentlyViewedProducts = RecentlyViewedProducts; 